// ========================================
// 📄 src/utils/helpers.js
// ========================================
export const getStatusBadgeColor = (status) => {
  const colors = {
    nouveau: "badge badge-warning",
    contacté: "badge badge-info",
    qualifié: "badge badge-success",
    en_négociation: "badge badge-warning",
    converti: "badge badge-success",
    perdu: "badge badge-danger",
  };
  return colors[status] || "badge badge-neutral";
};

export const getStatusLabel = (status) => {
  const labels = {
    nouveau: "Nouveau",
    contacté: "Contacté",
    qualifié: "Qualifié",
    en_négociation: "En Négociation",
    converti: "Converti",
    perdu: "Perdu",
  };
  return labels[status] || status;
};

export const calculateConversionRate = (leads) => {
  if (!leads || leads.length === 0) return 0;
  const converted = leads.filter((lead) => lead.status === "converti").length;
  return ((converted / leads.length) * 100).toFixed(1);
};

export const groupLeadsByStatus = (leads) => {
  return leads.reduce((acc, lead) => {
    const status = lead.status || "autre";
    if (!acc[status]) {
      acc[status] = [];
    }
    acc[status].push(lead);
    return acc;
  }, {});
};

export const sortLeadsByDate = (leads, order = "desc") => {
  return [...leads].sort((a, b) => {
    const dateA = a.createdAt?.toDate?.() || new Date(a.createdAt);
    const dateB = b.createdAt?.toDate?.() || new Date(b.createdAt);
    return order === "desc" ? dateB - dateA : dateA - dateB;
  });
};
